export const initialSafariPackagesState = {
    //for package listing
    safariPackagesData: [],
    summary: {},
    filters: {},
    pageIndex: 1,
    //for package View
    packageViewData: null,
    packageViewLoading: true,
    packageViewError: '',
    packageEnquriToggle: false,
    tabKey: 'overview',
    commentsUrl: '',
    userComments: [],
    summaryUserComment: {},
    pageIndexUserComment: 1,
    reportContentToggle: false,
    commentForFlag: null,
    //operator ratings
    operatorRatingPackage: [],
    ratingLoading: true

};

export const safariPackagesReducer = (state = initialSafariPackagesState, action) => {
    switch (action.type) {
        // for Package Listing
        case 'SET_SAFARI_PACKAGES_DATA':
            return {
                ...state,
                safariPackagesData: Array.isArray(action.payload)
                    ? action.payload
                    : state.safariPackagesData,
            };

        case 'APPEND_SAFARI_PACKAGES_DATA':
            return {
                ...state,
                safariPackagesData: [
                    ...state.safariPackagesData,
                    ...action.payload.filter(newItem =>
                        newItem.package_slug && !state.safariPackagesData.some(existing => existing.package_slug === newItem.package_slug)
                    ),
                ],
            };

        case 'SAFARI_PACKAGES_SUMMARY':
            return {
                ...state,
                summary: action.payload && typeof action.payload === 'object' ? action.payload : state.summary,
            };
        case 'SAFARI_PACKAGES_PAGE_INDEX':

            return {
                ...state,
                pageIndex: typeof action.payload === 'number' && !isNaN(action.payload)
                    ? action.payload
                    : state.pageIndex,
            };

        case 'SET_SAFARI_PACKAGES_FILTERS':
            return {
                ...state,
                filters: action.payload && typeof action.payload === 'object' ? action.payload : state.filters,
            };

        case 'UPDATE_SAFARI_PACKAGES_FILTER':
            return {
                ...state,
                filters: {
                    ...state.filters,
                    ...(action.payload && typeof action.payload === 'object' ? action.payload : {}),
                },
            };

        // for Package View
        case "SET_PACKAGE_VIEW_LOADING":
            return {
                ...state,
                packageViewLoading: typeof action.payload === "boolean" ? action.payload : state.packageViewLoading,
            };
        case 'SET_PACKAGE_VIEW_DETAILS':
            return {
                ...state,
                packageViewData: action.payload && typeof action.payload === 'object'
                    ? action.payload
                    : state.packageViewData,
            };
        case 'UPDATE_PACKAGE_VIEW_DETAILS':
            return {
                ...state,
                packageViewData: {
                    ...state.packageViewData,
                    ...(action.payload && typeof action.payload === 'object' ? action.payload : {}),
                },
            };
        case "SET_PACKAGE_VIEW_ERROR":
            return {
                ...state,
                packageViewError: typeof action.payload === "boolean" ? action.payload : state.packageViewError,
            };
        case "SET_PACKAGE_ENQURI_FORM_TOGGLE":
            return {
                ...state,
                packageEnquriToggle: typeof action.payload === "boolean" ? action.payload : state.packageEnquriToggle,
            };
        case "SET_PACKAGE_VIEW_TAB_KEY":
            return {
                ...state,
                tabKey: typeof action.payload === 'string' && action.payload.trim().length > 0 ? action.payload : state.tabKey,
            };
        //package comments    
        case "SET_PACKAGE_VIEW_COMMENTS_URL":

            return {
                ...state,
                commentsUrl: typeof action.payload === 'string' && action.payload.trim().length > 0 ? action.payload : state.comments,
            };
        case "SET_PACKAGE_VIEW_USERS_COMMENTS":
            return {
                ...state,
                userComments: Array.isArray(action.payload) ? action.payload : state.userComments,
            };
        case 'APPEND_PACKAGE_USERS_COMMENTS_DATA':

            return {
                ...state,
                userComments: [
                    ...state.userComments,
                    ...action.payload.filter(
                        newItem => !state.userComments.some(existing => existing.id === newItem.id)
                    ),
                ],
            };
        case "APPEND_REPLY_TO_COMMENT":
            const { parentId, reply } = action.payload;
            return {
                ...state,
                userComments: state.userComments.map((comment) =>
                    comment.id === parentId
                        ? {
                            ...comment,
                            replies: [...(comment.replies || []), reply], // append at end
                        }
                        : comment
                ),
            };
        case 'SF_USER_COMMENTS_PAGE_INDEX':
            return {
                ...state,
                pageIndexUserComment: typeof action.payload === 'number' && !isNaN(action.payload)
                    ? action.payload
                    : state.pageIndexUserComment,
            };
        case 'SF_USER_COMMENTS_SUMMARY':
            return {
                ...state,
                summaryUserComment: action.payload && typeof action.payload === 'object'
                    ? action.payload
                    : state.summaryUserComment,
            };
        case "SET_PACKAGE_REPORT_CONTENT_TOGGLE":
            return {
                ...state,
                reportContentToggle: typeof action.payload === "boolean" ? action.payload : state.reportContentToggle,
            };
        case "SET_PACKAGE_COMMENT_FOR_FLAG":
            return {
                ...state,
                commentForFlag: action.payload && typeof action.payload === 'object'
                    ? action.payload
                    : state.commentForFlag,
            };
        // for package operator rating
        case 'SET_PACKAGE_OPERATOR_RATING':
            return {
                ...state,
                operatorRatingPackage: Array.isArray(action.payload)
                    ? action.payload
                    : state.operatorRatingPackage,
            };
        case "SET_PACKAGE_OPERATOR_RATING_LOADING":
            return {
                ...state,
                ratingLoading: typeof action.payload === "boolean" ? action.payload : state.ratingLoading,
            };

        default:
            return state;
    }
};
